import { render, staticRenderFns } from "./selectClient.vue?vue&type=template&id=521669ae&scoped=true&"
import script from "./selectClient.vue?vue&type=script&lang=js&"
export * from "./selectClient.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "521669ae",
  null
  
)

export default component.exports